<template>
  <div class="app-page">
    <Header ref="header" helpURL="studio/profiler/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template #page-slot>
        Profiler
      </template>
    </Header>

    <div class="main-page-div">
      <main class="main-display-area">
        <div class="controls">
          <div class="controls__end">
            <div class="controls__actions">
              <ActionsButton
                label="Actions"
                :actions="profilerActions"
                @action-clicked="handleProfilerActionClick"
              />
            </div>
          </div>
        </div>

        <ProfileList
          :profiles="profiles"
          @profile-updated="loadProfiles"
          @add-validation-session="openAddValidationSessionDialog"
        />
      </main>
    </div>

    <AddProfilerSessionModal
      ref="addProfilerSessionModal"
      @profile-created="loadProfiles"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ActionsButton from '@/components/ActionsButton.vue';
import AddProfilerSessionModal from '@/components/ProfilerComponents/AddProfilerSessionModal.vue';
import ProfileList from '@/components/ProfilerComponents/ProfileList.vue';

const profiles = ref([]);
const addProfilerSessionModal = ref(null);
const profilerActions = [
  {
    icon: 'add',
    label: 'Add Profiling Session',
    eventKey: 'add-profiling-session',
    tooltip: 'Create a new profiling session',
  },
  {
    icon: 'delete',
    label: 'Delete Session',
    eventKey: 'delete-session',
    isAlert: true,
    tooltip: 'Delete selected profiling session',
  },
];

onMounted(async () => {
  await loadProfiles();
});


function normalizeProfileEntry(entry) {
  if (!entry || typeof entry !== 'object') {
    return {};
  }

  const isZeroDate = (value) => String(value || '').startsWith('0001-01-01');
  const createdAt = !isZeroDate(entry.created_date)
    ? entry.created_date
    : (!isZeroDate(entry.date) ? entry.date : '');

  return {
    ...entry,
    name: entry.name || entry.profile_name || (entry.id != null ? `Profile ${entry.id}` : '-'),
    description: entry.description || entry.message || entry.status_info?.message || '',
    status: entry.status || entry.status_info?.status || '',
    createdAt,
  };
}

function isProfileEntry(entry) {
  if (!entry || typeof entry !== 'object') return false;
  if (entry.type === 'profile') return true;
  if (entry.name || entry.description || entry.message) return true;
  if (entry.id != null && (entry.status || entry.date || entry.created_date)) return true;
  return false;
}

async function loadProfiles() {
  const dataConnect = new DatastoreConnect();
  try {
    const response = await dataConnect.api('profile.list', {});
    profiles.value = (response?.result?.tasks || [])
  } catch (error) {
    profiles.value = [];
  }
}

function handleProfilerActionClick(eventKey) {
  if (eventKey === 'add-profiling-session') {
    openAddValidationSessionDialog();
    return;
  }

  if (eventKey === 'delete-session') {
    return;
  }
}

function openAddValidationSessionDialog() {
  addProfilerSessionModal.value?.showModal?.();
}
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 20px;

  &__end {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

</style>
